<template>
  <article class="self-service-card organization-membership-status-card">
    <div class="card-heading">
      <div>
        <p class="section-kicker">单位会员关联</p>
        <h3>{{ title }}</h3>
      </div>
      <span class="organization-status" :class="statusClass">{{ statusText }}</span>
    </div>
    <dl class="organization-status-fields">
      <div><dt>申请关联单位</dt><dd>{{ front.organizationMembershipName || '—' }}</dd></div>
      <div><dt>个人会员身份</dt><dd>不变更</dd></div>
      <div><dt>单位权益范围</dt><dd>会议报名、会员会议价格、分会绑定</dd></div>
    </dl>
    <p class="service-hint">{{ description }}</p>
    <p v-if="front.organizationBindingReviewComment" class="organization-review-comment">
      审核意见：{{ front.organizationBindingReviewComment }}
    </p>
    <button
      v-if="front.organizationBindingStatus === 'REJECTED'"
      type="button"
      class="secondary-action compact"
      @click="front.upgradeToMemberPath"
    >
      改为申请个人会员
    </button>
  </article>
</template>

<script>
export default {
  name: 'OrganizationMembershipStatusCard',
  inject: ['front'],
  computed: {
    title() {
      if (this.front.organizationBindingStatus === 'ACTIVE' && this.front.organizationMemberBenefit) return '单位会员权益已生效'
      if (this.front.organizationBindingStatus === 'ACTIVE') return '单位会员权益当前未生效'
      if (this.front.organizationBindingStatus === 'REJECTED') return '单位会员关联未通过'
      return '单位会员关联待秘书处确认'
    },
    statusText() {
      if (this.front.organizationBindingStatus === 'ACTIVE' && this.front.organizationMemberBenefit) return '已生效'
      if (this.front.organizationBindingStatus === 'ACTIVE') return '已暂停'
      if (this.front.organizationBindingStatus === 'REJECTED') return '未通过'
      return '待确认'
    },
    statusClass() {
      if (this.front.organizationBindingStatus === 'ACTIVE' && this.front.organizationMemberBenefit) return 'is-active'
      if (this.front.organizationBindingStatus === 'ACTIVE') return 'is-rejected'
      if (this.front.organizationBindingStatus === 'REJECTED') return 'is-rejected'
      return 'is-pending'
    },
    description() {
      if (this.front.organizationBindingStatus === 'ACTIVE' && this.front.organizationMemberBenefit) {
        return '您可在单位会员有效期内使用会员会议权益，但不会获得个人会员证书，也不参与终身会员管理。'
      }
      if (this.front.organizationBindingStatus === 'ACTIVE') {
        return '关联关系仍保留，但单位会员当前已到期、已注销或尚未到生效日期，因此暂不授予会员权益。请联系秘书处核对或续费。'
      }
      if (this.front.organizationBindingStatus === 'REJECTED') {
        return '您当前仍可按非会员身份使用基础服务。如单位信息有误，请联系秘书处核对。'
      }
      return '确认前您可以按非会员身份使用基础服务；秘书处审核通过后，单位会员权益将自动生效。'
    }
  }
}
</script>

<style scoped>
.organization-membership-status-card { display: grid; gap: 18px; }
.organization-status { padding: 5px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; }
.organization-status.is-active { background: #e8f7ee; color: #147a3a; }
.organization-status.is-pending { background: #fff4d6; color: #8a5a00; }
.organization-status.is-rejected { background: #feeceb; color: #a3312c; }
.organization-status-fields { display: grid; margin: 0; border: 1px solid rgba(31, 79, 122, 0.12); border-radius: 8px; overflow: hidden; }
.organization-status-fields div { display: grid; grid-template-columns: 140px 1fr; gap: 14px; padding: 12px 14px; border-bottom: 1px solid rgba(31, 79, 122, 0.08); }
.organization-status-fields div:last-child { border-bottom: 0; }
.organization-status-fields dt { color: #627386; font-weight: 600; }
.organization-status-fields dd { margin: 0; color: #20374d; font-weight: 700; }
.organization-review-comment { margin: 0; padding: 12px 14px; border-radius: 8px; background: #fff7ed; color: #8a4b08; }
</style>
